import { createSlice } from '@reduxjs/toolkit';

// Define the initial state
const initialState = {
  value: 0,
};

export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
  },
});

// Export actions
export const { increment, decrement, incrementByAmount } = counterSlice.actions;

// Export selectors
export const selectCount = (state) => state.counter.value;

// Export reducer
export default counterSlice.reducer;
